/* React core */
import { Component } from "react"

/* Icon component */
import Icon from "./Icon"

/* Translation */
import { translate } from "../translates"

/* Component FilterDropdown */
class FilterDropdown extends Component {

    constructor(props) {
        super(props)
        /* State */
        this.state = { open: false }
    }

    render = () => {
        /* Fields */
        const { label, icon, value, options, onChange } = this.props
        const active = value && value !== options[0].id
        const current = options.find((o) => o.id === value)
        return (
            <div style={{ position: "relative" }}>
                <button className={`filter ${active ? "is-active" : ""}`} onClick={() => this.setState({ open: !this.state.open })}>
                    {icon && <Icon name={icon} size={14} />}
                    {active ? translate(current.label) : label} <Icon name="chevron_down" size={14} />
                </button>
                {this.state.open && (
                    <div className="filter-drop">
                        <div onClick={() => this.setState({ open: false })} style={{ position: "fixed", inset: 0, zIndex: 19 }} />
                        <div className="filter-pop">
                            {options.map((o) => (
                                <button key={o.id} className={value === o.id ? "is-sel" : ""} onClick={() => { onChange(o.id); this.setState({ open: false }) }}>
                                    {translate(o.label)}
                                    {value === o.id && <Icon name="check" size={14} />}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

/* Export */
export default FilterDropdown
